export const authStepsList = {
  profile: 1,
  name: 2,
  address: 3,
  'verify-email': 4,
  phonenumber: 6,
  verification: 6,
  topics: 7,
  groups: 8,
  lets_go: 9
}
